import classNames from 'classnames';
import type { IntlKey } from 'locales';
import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
export type BadgeProps = {
  translationFunc: (id: string) => IntlKey;
  children: ReactNode;
  className?: string;
  onDismiss?: (id: string) => void;
  id: string;
};

const BadgeSpan = styled.span`
  min-height: 20px;
`;

export function Badge({ children, translationFunc, className, id, onDismiss }: BadgeProps): React.JSX.Element {
  const { formatMessage } = useIntl();
  return (
    <BadgeSpan className={classNames('badge badge-discreet-info badge-dismissible', className)} key={id}>
      {onDismiss && (
        <button type="button" className="btn" onClick={() => onDismiss?.(id)}>
          <em className="icon">close</em>
        </button>
      )}
      {formatMessage({ id: translationFunc(id) })} : {children}
    </BadgeSpan>
  );
}
